export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const SESSION_ID_KEY = 'sessionid';
export const USERNAME_KEY = 'username';
export const CSRF_TOKEN_KEY = 'csrftoken';
